export const actions = {
  updateIsLoading({ commit }, { isLoading = false }) {
    commit('setIsLoading', { isLoading });
  },

  updateIsShowPopup({ commit }, isShowPopup) {
    commit('setIsShowPopup', isShowPopup);
  },

  pushModalAlertComponent({ state, commit }, payload) {
    state.modalAlertComponents.push(payload);
    commit('setModalAlertComponents', {
      modalAlertComponents: state.modalAlertComponents
    });
  },
  removeAllModalAlertComponent({ commit }) {
    commit('setModalAlertComponents', {
      modalAlertComponents: []
    });
  },
  closeModalAlertComponent({ state, commit }, { index = 0 }) {
    state.modalAlertComponents.splice(index, 1);
    commit('setModalAlertComponents', {
      modalAlertComponents: state.modalAlertComponents
    });
  },
  pushModalComponent({ state, commit }, payload) {
    state.modalComponents.push(payload);
    commit('setModalComponents', {
      modalComponents: state.modalComponents
    });
  },
  removeAllModalComponent({ commit }) {
    commit('setModalComponents', {
      modalComponents: []
    });
  },
  closeModalComponent({ state, commit }, { index = 0 }) {
    state.modalComponents.splice(index, 1);
    commit('setModalComponents', {
      modalComponents: state.modalComponents
    });
  },
  updateRouteLayout({ commit }, payload) {
    commit('setRouteLayout', payload);
  },
  updateKeywords({ getters, commit }, { keyword }) {
    const keywords = getters.getKeywords;
    keywords.unshift(keyword);
    commit('setKeywords', { keywords });
  }
};
